import YOUTUBE_STREAM_URL from '../../constants/youtubeStreamUrl'

const isRtmpUrl = (value) => /^rtmps?:\/\//i.test(value.trim())

// The backend stores the stream destination verbatim, so the wire value must be a full
// rtmp(s):// URL. A bare value is a YouTube stream key, so prefix it with YouTube's ingest base;
// a value that is already a full URL (custom server or a pasted YouTube URL) is sent as-is.
const ensureFullRtmpDestination = (value) => {
  if (!value) return value
  return isRtmpUrl(value) ? value : `${YOUTUBE_STREAM_URL}${value.trim()}`
}

export default ensureFullRtmpDestination
